module.exports = __webpack_public_path__ + "static/background-60fcad3ed9c06803f3b37304ed106d50.svg";